var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pss__sider"},[_c('sider-head'),_c('sider-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }